import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import Autocomplete from "@/ui/molecules/Autocomplete";
import type { UserDatabase } from "@/ui/organisms/userTypes";
import { Button, Icon, IconBox, Modal } from "@proda-ai/ui-kit";
import React from "react";

export type ViewSelectDatabaseModalParams = {
    useState: () => {
        showModal: boolean;
        availableDatabases: UserDatabase[];
        selectedDatabase: number;
    };
    useCases: () => {
        onConfirm: () => void;
        onCancel: () => void;
        onSelectDatabase: (databaseId: number) => void;
    };
};

export const createViewSelectDatabaseModal = ({
    useState,
    useCases,
}: ViewSelectDatabaseModalParams) => {
    const SelectDatabaseModal = () => {
        const { showModal, selectedDatabase, availableDatabases } = useState();
        const { onConfirm, onCancel, onSelectDatabase } = useCases();

        const databaseOptionsAsAutocompleteOptions = React.useMemo(
            () =>
                availableDatabases.map(database => ({
                    value: database.databaseId,
                    label: database.databaseName,
                })),
            [availableDatabases],
        );

        const selectDatabaseModalTitle = () => {
            return (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 0.5,
                        alignItems: "center",
                    }}
                >
                    Create Project
                </Box>
            );
        };

        const renderModalFooter = () => {
            return (
                <Box
                    sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
                >
                    <Button onClick={onCancel} pattern="secondary" size="large">
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        pattern="primary"
                        size="large"
                        disabled={selectedDatabase === -1}
                    >
                        Select
                    </Button>
                </Box>
            );
        };

        return (
            <Modal
                hideCloseButton
                open={showModal}
                headerTitle={selectDatabaseModalTitle()}
                onClose={onCancel}
                footer={renderModalFooter()}
                isDynamicSizing={true}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                        marginBottom: "0.5rem",
                        paddingLeft: "0.5rem",
                    }}
                >
                    <IconBox>
                        <Icon icon="server" />
                    </IconBox>
                    <Typography variant="body2">
                        Select the Database to add to:
                    </Typography>
                </Box>
                <Autocomplete
                    label="Select Database"
                    hideLabel={true}
                    placeholder="Select Database"
                    options={databaseOptionsAsAutocompleteOptions}
                    value={selectedDatabase}
                    onChange={(value: number) => {
                        onSelectDatabase(value);
                    }}
                    sx={{
                        width: "500px",
                        minWidth: "320px",
                    }}
                />
            </Modal>
        );
    };
    return SelectDatabaseModal;
};
